module.exports = __webpack_public_path__ + "img/UTFREM-4.4b3008dc.jpg";